import { gql } from '@apollo/client';

import { Vehicle } from '../api.graphql';

export const ListingCreatedGQL = gql`
  subscription listingCreatedSubscription {
    listingCreated {
      id
    }
  }
`;

export const ListingUpdatedGQL = gql`
  subscription listingUpdatedSubscription {
    listingUpdated {
      id
      totalCosts
      totalProfit
    }
  }
`;

export const VehicleUpdatedSubscriptionGQL = gql`
  subscription VehicleUpdatedSubscription {
    vehicleUpdated {
      id
    }
  }
`;

export const BulkProcessUpdatedGQL = gql`
  subscription bulkProcessUpdated {
    bulkProcessUpdated {
      id
      actionType
      status
      actor {
        id
      }
    }
  }
`;

export interface VehicleSubscriptionUpdated {
  subscriptionData: {
    data: {
      vehicleUpdated: Vehicle;
    };
  };
}
